import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import FeedbackForm from '../account/feedbackForm';
import { ensureNamespaces } from '../../i18n';

import {
  ContactsContent,
  ContactsDescription,
  ContactsEmailLink,
  ContactsFormCard,
  ContactsFormTitle,
  ContactsRow,
  ContactsSection,
  ContactsTitle,
  LandingContainer,
} from './landingPage.styles';

export default function LandingContactsSection() {
  const { t } = useTranslation(['landing', 'account']);

  useEffect(() => {
    ensureNamespaces(['landing']);
  }, []);

  return (
    <ContactsSection id="contacts">
      <LandingContainer>
        <ContactsRow>
          <ContactsContent>
            <ContactsTitle>{t('landing:contacts.title')}</ContactsTitle>
            <ContactsDescription>{t('landing:contacts.description')}</ContactsDescription>
            <ContactsEmailLink href="mailto:info@healthy-pet.app">
              info@healthy-pet.app
            </ContactsEmailLink>
          </ContactsContent>

          <ContactsFormCard>
            <ContactsFormTitle>{t('landing:contacts.formTitle')}</ContactsFormTitle>
            <FeedbackForm showSubtitle withPanel subtitleInsidePanel routeOverride="/" />
          </ContactsFormCard>
        </ContactsRow>
      </LandingContainer>
    </ContactsSection>
  );
}
